import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, isFavorite: Boolean }
  static targets = [ "icon" ]

  async toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })

    if (response.ok) {
      const json = await response.json()
      this.isFavoriteValue = json.is_favorite
      this.updateIcon()
    }
  }

  updateIcon() {
    if (!this.hasIconTarget) return
    if (this.isFavoriteValue) {
      this.iconTarget.classList.remove("text-beige-300", "fill-none")
      this.iconTarget.classList.add("text-amber-400", "fill-current")
      this.iconTarget.setAttribute("fill", "currentColor")
    } else {
      this.iconTarget.classList.remove("text-amber-400", "fill-current")
      this.iconTarget.classList.add("text-beige-300", "fill-none")
      this.iconTarget.setAttribute("fill", "none")
    }
  }
}
